import { IIconProps } from '../../types';
import SimpleIconWrap from './simple-icon-wrap';

const IconAdd = ({ id, color, width = 51, style, onClick }: IIconProps) => {
  const viewBoxWidth = 51;
  const viewBoxHeight = 51;

  return (
    <SimpleIconWrap
      onClick={onClick}
      id={id}
      viewBox={[0, 0, viewBoxWidth, viewBoxHeight]}
      width={width}
      style={style}
      color={color}
      path="M28.557 48.27a2.73 2.73 0 0 1-5.46 0V28.557H2.73a2.73 2.73 0 0 1 0-5.46h20.367V2.73a2.73 2.73 0 1 1 5.46 0v20.367H48.27a2.73 2.73 0 0 1 0 5.46H28.557V48.27z"
    />
  );
};

export default IconAdd;
